import {
  AUDIO_PLAYER_HEIGHT,
  ICON_BUTTON_WIDTH,
  TIME_LINE_HEIGHT,
} from 'd2/components/AudioPlayer/constants'
import { FONT_SIZE_LARGE } from 'd2/constants/fonts'
import {
  MAX,
  NONE,
  SPACING,
  SPACING_HALF,
} from 'd2/constants'
import { px } from 'd2/utils/style'
import makeStyles from 'd2/hooks/tss/makeStyles'
import type { MergedThemes } from 'd2/types'

const createBorder: (a: string) => string = (color) => `${px(1)} solid ${color}`

const styles = (theme: MergedThemes) => ({
  audioInfo: {
    padding: `${px(TIME_LINE_HEIGHT)} ${px(SPACING_HALF)} 0 ${px(SPACING_HALF)}`,
  },
  audioPlayer: {
    border: theme.branding && createBorder(theme.branding.primaryColor),
    borderBottom: NONE,
    height: px(AUDIO_PLAYER_HEIGHT),
  },
  iconButton: {
    fontSize: px(FONT_SIZE_LARGE),
    width: px(ICON_BUTTON_WIDTH),
  },
  iconButtonWrapper: {
    borderBottom: NONE,
    borderRight: theme.branding && createBorder(theme.branding.primaryColor),
    display: 'flex',
    height: MAX,
  },
  progressBar: {
    borderBottom: theme.branding && createBorder(theme.branding.primaryColor),
    borderLeft: theme.branding && createBorder(theme.branding.primaryColor),
    borderRight: theme.branding && createBorder(theme.branding.primaryColor),
  },
  timeContainer: {
    paddingLeft: px(SPACING_HALF),
  },
  truncate: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    width: px(1), // TODO: figure out why we need to set width, and why this width is not being honored
  },
  volumeButtonWrapper: {
    borderBottom: NONE,
    borderLeft: theme.branding && createBorder(theme.branding.primaryColor),
    display: 'flex',
    height: MAX,
    marginLeft: SPACING,
  },
} as const)

export default makeStyles({
  name: 'DisconnectedAudioPlayer',
})(styles)
